import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import {
  startApplication,
  clearState,
} from "../store/slices/applicationFormSlice";

export default function StartApplication() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handle = {
    startApplication: () => {
      dispatch(clearState());
      dispatch(startApplication()).then(({ payload }) => {
        const newApplicationId = payload?.data?.application?._id;
        if (newApplicationId) {
          navigate(`/dashboard/application/${newApplicationId}`);
        }
      });
    },
  };

  return (
    <>
      <Button
        color="secondary"
        variant="contained"
        size="small"
        onClick={handle.startApplication}
        style={{ marginRight: "30px" }}
      >
        New application
      </Button>
    </>
  );
}
